/**
 * Ensures the search_knowledge_base function tool is added/removed based on
 * the corpora map (Gemini equivalent of ensureFileSearchTool).
 *
 * Builds a function declaration per corpus map so the model knows which
 * knowledge bases it can query and what slugs to pass as `source`.
 *
 * @param {Array}  tools   - Current tools array
 * @param {Object} corpora - Map of slug → resourceName, e.g. { hr_policies: "projects/.../ragCorpora/111" }
 * @returns {Array} Updated tools array
 */
export function ensureRagRetrievalTool(tools = [], corpora = {}) {
    const corporaKeys = Object.keys(corpora || {});
    let updatedTools = [...tools];

    // Remove any existing retrieval or search_knowledge_base tools
    updatedTools = updatedTools.filter(tool => {
        if (tool.retrieval || tool.type === "retrieval") return false;
        if (tool.functionDeclarations?.some(fd => fd.name === "search_knowledge_base")) return false;
        return true;
    });

    if (corporaKeys.length > 0) {
        updatedTools.push({
            functionDeclarations: [{
                name: "search_knowledge_base",
                description: "Search the available knowledge bases for relevant information.",
                parameters: {
                    type: "object",
                    properties: {
                        query: { type: "string" },
                        source: { type: "string", enum: corporaKeys }
                    },
                    required: ["query", "source"]
                }
            }]
        });
    }

    return updatedTools;
}
